import * as z from "zod";

export const getAvgClaimValueByCarrier = {
  name: "getAvgClaimValueByCarrier" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    carriers: z.array(z.object({ carrier: z.string(), avgValue: z.number() })),
  }),
};
